"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SITES = void 0;
exports.DEFAULT_SITES = [
    {
        id: "328ea5dd-5c01-405a-bc64-0212061c4164",
        name: "Q2RS",
    },
    {
        id: "508af0b5-8c40-4648-861f-26d60d3a712f",
        name: "Q3SP",
    },
    {
        id: "69fe2850-dc56-4d4d-af3a-d48ce24b9ffb",
        name: "Q4DCX",
    },
    {
        id: "8ff6fcbe-ba25-4bef-b266-d43a177b1d75",
        name: "Q3ABC",
    },
    {
        id: "d1567fbc-ad31-4a6f-b4cd-7330cecfc2bc",
        name: "Q1BA",
    },
];
